// extracted by mini-css-extract-plugin
export default {"p":"ed2ede13fe _875f1e1989 _54bac6f3a0","clr":"_194f06ebe3","dls":"b48c314580"};